import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Button from '../../Common/Button';
import '../Reports.scss';
import { CsvToIntArray } from '../../../helpers/strings';
import { getDateValue } from '../../../helpers/reports';

export class MilestoneCrosstabFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            baselineIds: '',
            disciplineIds: '',
            brandIds: '',
            locationTypeIds: '',
            managementCompanyIds: '',
            openingDateStart: '',
            openingDateEnd: '',
            projectManagerIds: '',
            departmentIds: '',
            phaseIds: '',
            continentIds: '',
            areaIds: '',
            regionIds: '',
            columnKeys: ''
        }

        this.state = {
            emptyForm: initialFormSelections,
            showMoreFields: false,

            baselineIds: initialFormSelections.baselineIds,
            disciplineIds: initialFormSelections.disciplineIds,
            brandIds: initialFormSelections.brandIds,
            locationTypeIds: initialFormSelections.locationTypeIds,
            managementCompanyIds: initialFormSelections.managementCompanyIds,
            openingDateStart: initialFormSelections.openingDateStart,
            openingDateEnd: initialFormSelections.openingDateEnd,
            projectManagerIds: initialFormSelections.projectManagerIds,
            departmentIds: initialFormSelections.departmentIds,
            phaseIds: initialFormSelections.phaseIds,
            continentIds: initialFormSelections.continentIds,
            areaIds: initialFormSelections.areaIds,    
            regionIds: initialFormSelections.regionIds,

            columnKeys: initialFormSelections.columnKeys,
            columnKeysOptions: [
                { id: 'Area', name: 'Area' },
                { id: 'Brand', name: 'Brand' },
                { id: 'Continent', name: 'Continent' },
                { id: 'Country', name: 'Country' },
                { id: 'LocationType', name: 'Location Type' },
                { id: 'ManagementCompany', name: 'Management Company' },
                { id: 'Region', name: 'Region' },
                { id: 'OpeningDate', name: 'Opening Date' }
            ]
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = { ...this.state };

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,

                baselineIds: appState.baselineIds ? appState.baselineIds : newState.baselineIds,
                disciplineIds: appState.disciplineIds ? appState.disciplineIds : newState.disciplineIds,
                brandIds: appState.brandIds ? appState.brandIds : newState.brandIds,
                locationTypeIds: appState.locationTypeIds ? appState.locationTypeIds : newState.locationTypeIds,
                managementCompanyIds: appState.managementCompanyIds ? appState.managementCompanyIds : newState.managementCompanyIds,
                openingDateStart: appState.openingDateStart ? appState.openingDateStart : newState.openingDateStart,
                openingDateEnd: appState.openingDateEnd ? appState.openingDateEnd : newState.openingDateEnd,
                projectManagerIds: appState.projectManagerIds ? appState.projectManagerIds : newState.projectManagerIds,
                departmentIds: appState.departmentIds ? appState.departmentIds : newState.departmentIds,
                phaseIds: appState.phaseIds ? appState.phaseIds : newState.phaseIds,
                continentIds: appState.continentIds ? appState.continentIds : newState.continentIds,
                areaIds: appState.areaIds ? appState.areaIds : newState.areaIds,
                regionIds: appState.regionIds ? appState.regionIds : newState.regionIds,
                columnKeys: appState.columnKeys ? appState.columnKeys : newState.columnKeys
            }
        }

        this.setState({
            ...this.state,
            ...newState
        });

    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        if (!this.state.baselineIds || this.state.baselineIds.trim().length <= 0) {
            return false;
        }

        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };

        form.baselineIds = (reportRequest.baselineIds) ? reportRequest.baselineIds.join(',') : form.baselineIds;
        form.disciplineIds = (reportRequest.disciplineIds) ? reportRequest.disciplineIds.join(',') : form.disciplineIds;
        form.brandIds = (reportRequest.brandIds) ? reportRequest.brandIds.join(',') : form.brandIds;
        form.locationTypeIds = (reportRequest.locationTypeIds) ? reportRequest.locationTypeIds.join(',') : form.locationTypeIds;
        form.managementCompanyIds = (reportRequest.managementCompanyIds) ? reportRequest.managementCompanyIds.join(',') : form.managementCompanyIds;
        form.openingDateStart = getDateValue(reportRequest.openingDateStart);
        form.openingDateEnd = getDateValue(reportRequest.openingDateEnd);
        form.projectManagerIds = (reportRequest.projectManagerIds) ? reportRequest.projectManagerIds.join(',') : form.projectManagerIds;
        form.departmentIds = (reportRequest.departmentIds) ? reportRequest.departmentIds.join(',') : form.departmentIds;
        form.phaseIds = (reportRequest.phaseIds) ? reportRequest.phaseIds.join(',') : form.phaseIds;
        form.continentIds = (reportRequest.continentIds) ? reportRequest.continentIds.join(',') : form.continentIds;
        form.areaIds = (reportRequest.areaIds) ? reportRequest.areaIds.join(',') : form.areaIds;
        form.regionIds = (reportRequest.regionIds) ? reportRequest.regionIds.join(',') : form.regionIds; 
        form.columnKeys = (reportRequest.columnKeys) ? reportRequest.columnKeys.join(',') : form.columnKeys;      

        this.setState({
            ...this.state,
            ...form
        });

    }

        /**
     * When an API request is going to be made, we also want to save the state
     * of our form entries into redux, so that saved state can be loaded when
     * this report is scheduled or simply reloaded later.  To accomplish that
     * from the centralized ReportDataHelper, we return both the apiRequest
     * object as well as the current state of our form.  This separation allows
     * for differences in the apiRequest format/naming conventions and those of
     * the form fields.
     */
    mapToApiRequest = () => {

        let columnKeys = null;
        if (this.state.columnKeys && this.state.columnKeys.trim().length > 0) {
            columnKeys = this.state.columnKeys.split(',');
        }

        const request = {
            reportId: this.props.report.id,

            baselineIds: CsvToIntArray(this.state.baselineIds),
            disciplineIds: CsvToIntArray(this.state.disciplineIds),
            brandIds: CsvToIntArray(this.state.brandIds),
            locationTypeIds: CsvToIntArray(this.state.locationTypeIds),
            managementCompanyIds: CsvToIntArray(this.state.managementCompanyIds),
            openingDateStart: this.state.openingDateStart,
            openingDateEnd: this.state.openingDateEnd,
            projectManagerIds: CsvToIntArray(this.state.projectManagerIds),
            departmentIds: CsvToIntArray(this.state.departmentIds),
            phaseIds: CsvToIntArray(this.state.phaseIds),
            continentIds: CsvToIntArray(this.state.continentIds),
            areaIds: CsvToIntArray(this.state.areaIds),
            regionIds: CsvToIntArray(this.state.regionIds),
            columnKeys: columnKeys
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onFieldChange = (name, value) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    onDatePickerChange = (date, name) => {
        this.onFieldChange(name, date);
    }

    onToggleShowMore = () => {
        this.setState({
            showMoreFields: !this.state.showMoreFields
        });
    }

    render() {
        const showMoreText = this.state.showMoreFields ? "Show Less Filters" : "Show More Filters";

        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="baselineIds"
                            label="Baseline" idField="id" valueField="name"
                            options={this.props.filters.baselines}
                            selectedValues={this.state.baselineIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={true}
                            errorMessage="Baseline is required"
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="disciplineIds"
                            label="Discipline" idField="id" valueField="name"
                            options={this.props.filters.disciplines}
                            selectedValues={this.state.disciplineIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="brandIds"
                            label="Brand" idField="id" valueField="name"
                            options={this.props.filters.brands}
                            selectedValues={this.state.brandIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>                    
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="locationTypeIds"
                            label="Location Type" idField="id" valueField="name"
                            options={this.props.filters.locationTypes}
                            selectedValues={this.state.locationTypeIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="managementCompanyIds"
                            label="Management Company" idField="id" valueField="name"
                            options={this.props.filters.managementCompanies}
                            selectedValues={this.state.managementCompanyIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>    
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="openingDateStart"
                            value={this.state.openingDateStart}
                            label="Opening Date From"
                            onChange={this.onDatePickerChange} />
                    </div>
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="openingDateEnd"
                            value={this.state.openingDateEnd}
                            label="To"
                            onChange={this.onDatePickerChange} />
                    </div>                                   
                </div>

                { this.state.showMoreFields &&
                    <Fragment>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="projectManagerIds"
                                    label="Project Manager" idField="id" valueField="name"
                                    options={this.props.filters.projectManagers}
                                    selectedValues={this.state.projectManagerIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="departmentIds"
                                    label="Department" idField="id" valueField="name"
                                    options={this.props.filters.departments}
                                    selectedValues={this.state.departmentIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="phaseIds"
                                    label="Phase" idField="id" valueField="name"
                                    options={this.props.filters.phases}
                                    selectedValues={this.state.phaseIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="continentIds"
                                    label="Continent" idField="id" valueField="name"
                                    options={this.props.filters.continents}
                                    selectedValues={this.state.continentIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="areaIds"
                                    label="Area" idField="id" valueField="name"
                                    options={this.props.filters.areas}
                                    selectedValues={this.state.areaIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="regionIds"
                                    label="Region" idField="id" valueField="name"
                                    options={this.props.filters.regions}
                                    selectedValues={this.state.regionIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isRequired={false}
                                    isMulti={true} />
                            </div>                            
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="columnKeys"
                                    label="Include Columns" idField="id" valueField="name"
                                    options={this.state.columnKeysOptions}
                                    selectedValues={this.state.columnKeys.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true}
                                    isRequired={true}
                                    errorMessage="One column is required" />                                
                            </div>
                        </div>              
                    </Fragment>
                }
                <div className="row text-end">
                    <div className="col-sm-12">
                        <Button name="showMore" type="button" bootstrapClass="link" text={showMoreText} onClick={this.onToggleShowMore} />
                    </div>
                </div>                
            </form>
        )
    }
}

MilestoneCrosstabFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    savedFilterValues: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired
 };

 export default MilestoneCrosstabFilters;